'use client';

import { ReactNode } from 'react';

import cn from '@/helpers/utils/classNames';

import '@/styles/globals.v2.css';

export interface TopCodeBarProps {
  className?: string;
  children: ReactNode;
}

export default function TopCodeBar({ children, className }: TopCodeBarProps) {
  return (
    <div
      className={cn(
        'v2-w-full v2-bg-primary v2-pt-[31px] v2-pb-[30px] md:v2-pt-[31px] md:v2-pb-[30px] sm:v2-py-[11px] xs:v2-py-[11px] v2-text-center v2-text-white',
        className
      )}
    >
      {children}
    </div>
  );
}
